import { isInIFrame } from 'is-iframe'
import mixpanel from 'mixpanel-browser'
import config from '../config'
import analytics from './analytics'
import parentEmitter from './parentEmitter'

function navigateToHrLogin(email?: string, token?: string) {
  console.warn('Redirecting to hr website...')
  const distinctId = mixpanel.get_distinct_id()

  const redirect_url = token ? `${config.hr_app_url}/login?token=${token}&distinct_id=${distinctId}` : `${config.hr_app_url}/login?login=${email}&type=emailOnly`

  if (isInIFrame()) {
    analytics.sendEvent('Onboard@RedirectToHr')
    window.onbeforeunload = null

    // new redirect. Designed and connected to hr website
    parentEmitter.sendRedirectEvent('hr', { email })

    // old redirect. Handler somewhere in wordpress.
    window.parent.postMessage(`location---${redirect_url}`, config.cmsFrameLink)
  } else {
    // if we use onboarding from direct domain, let's redirect
    window.location.href = redirect_url
  }
}

export default {
  navigateToHrLogin,
}
